import React, { useEffect } from 'react';
import QueriesManager from '../QueriesManager/QueriesManager';
import CustomQuery from '../CustomQuery/CustomQuery';
import { useSelector, useDispatch } from 'react-redux';
import { Subsection, StyledSpan, MainDiv, StyledTab, StyledTabs, StyledAppBar } from './QueryBuilderStyle';
import { pushActiveTab, resetCustomQuery } from '../../slices/customQuerySlice';
import { resetQueriesManager } from '../../slices/QueriesManagerSlice';
import { resetCustomQueryBody } from '../../slices/customQueryBodySlice';
import { resetOperationCard } from '../../slices/OperationsCardSlice';
import { resetEntityCard } from '../../slices/entityCardSlice';
import { pushPostApiResponse, resetCustomQueryHeader } from '../../slices/customQueryHeaderSlice';

const QueryBuilder = () => {
  const activeTab = useSelector(state => state.customQuery.activeTab);
  const dispatch = useDispatch();
  const tabs = [{
    id: 1,
    label: 'Queries Manager',
    component: /*#__PURE__*/React.createElement(QueriesManager, null)
  }, {
    id: 2,
    label: 'Custom Query',
    component: /*#__PURE__*/React.createElement(CustomQuery, null)
  }];

  const handleChange = (event, activeTab) => {
    dispatch(pushActiveTab(activeTab));
  };

  useEffect(() => {
    const unMountFunc = () => {
      let data = {
        data: '',
        type: 'run'
      };
      dispatch(pushPostApiResponse(data));
      let savedata = {
        data: '',
        type: 'save'
      };
      dispatch(pushPostApiResponse(savedata));
      dispatch(resetCustomQueryHeader());
      dispatch(resetCustomQueryBody());
      dispatch(resetCustomQuery());
      dispatch(resetOperationCard());
      dispatch(resetQueriesManager());
      dispatch(resetEntityCard());
    }; // returned function will be called on component unmount


    return () => {
      unMountFunc();
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Subsection, null, /*#__PURE__*/React.createElement(StyledSpan, null, "Query Engine")), /*#__PURE__*/React.createElement(MainDiv, null, /*#__PURE__*/React.createElement(StyledAppBar, {
    position: "static"
  }, /*#__PURE__*/React.createElement(StyledTabs, {
    value: activeTab,
    onChange: handleChange
  }, tabs.map(tab => /*#__PURE__*/React.createElement(StyledTab, {
    key: tab.id,
    label: tab.label,
    value: tab.id,
    icon: tab.icon,
    classes: {
      wrapper: activeTab === tab.id ? 'active-tab-style' : 'tab-style'
    }
  })))), tabs.map(tab => activeTab === tab.id ? /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%'
    },
    key: tab.id
  }, tab.component) : null)));
};

export default QueryBuilder;